import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * On/off switch. Off: hollow track with an ash knob. On: ink track with a
 * knob in the inverse colour. Supports `[(checked)]`.
 */
@Component({
  selector: 'app-toggle',
  standalone: true,
  imports: [],
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.css',
})
export class ToggleComponent {
  @Input() checked = true;
  /** Accessible name when no visible label is associated with the switch. */
  @Input() label = '';
  @Input() disabled = false;
  /** Emits the new state each time the switch is flipped. */
  @Output() checkedChange = new EventEmitter<boolean>();

  onChange(event: Event): void {
    this.checked = (event.target as HTMLInputElement).checked;
    this.checkedChange.emit(this.checked);
  }
}
